import React from "react";
import MicrosoftSvg from "assets/svg/microsoft";
import YoutubeSvg from "assets/svg/youtubesvg";
import BloombergSvg from "assets/svg/bloomberg";
import SpotifySvg from "assets/svg/spotify";
import WixSvg from "assets/svg/wix";
import HsbcSvg from "assets/svg/hsbc";
import SapSvg from "assets/svg/sap";
import OptimizedImage from "hooks/OptimizedImage";

export default function TranslateAgency({
  BackgroundCol,
  content,
  head,
  colorHead,
  lastHeadText,
  coloR,
  styleOne,
  firstWord,
  vow,
}) {


  return (
    <section
      className={`${
        BackgroundCol ? BackgroundCol : "bg-darkBlue"
      } py-24 relative`}
    >
      <OptimizedImage
        src="https://tomedes.gumlet.io/frontend/images/home-en/Industry_dots.webp"
        alt="dots"
        className="invisible lg:visible absolute top-0 left-0 w-[103px] h-64"
      />
      <div className="container mx-auto px-4">
        {firstWord ? (
          <h1 className="text-gray text-3xl md:text-4xl text-center font-secondary leading-10">
            {head ? head : `${vow} ${firstWord} Translation Company you can `}
            <span className={`${coloR ? coloR : "text-lightBlue"}`}>
              {colorHead ? colorHead : "Trust"}
            </span>
            &nbsp;
            <span className="text-white">{lastHeadText}</span>
          </h1>
        ) : (
          <h1 className="text-gray text-3xl md:text-4xl text-center font-secondary leading-10">
            {head ? head : "A Translation Agency you can "}
            <span className={`${coloR ? coloR : "text-lightBlue"}`}>
              {colorHead ? colorHead : "Trust"}
            </span>
            &nbsp;
            <span className="text-white">{lastHeadText}</span>
          </h1>
        )}

        <p className="text-lightGray font-opensans text-[18px] text-center py-4 leading-[32px] px-10 lg:max-w-5xl lg:mx-auto">
          {content
            ? content
            : "95,000 clients have entrusted Tomedes with their business. These include private individuals, small to medium businesses, and the largest corporations, leading brands, national and local governments. But most importantly: we're here for you. Right now."}
        </p>

        {styleOne == "1" ? (
          <div className="mx-auto pt-10 text-center">
            <div className="w-11/12  sm:w-10/12 mx-auto grid grid-cols-2 md:grid-cols-3 lg:grid-cols-7 gap-8 sm:gap-7 2xl:gap-10 justify-items-center md:justify-items-center pt-[15px] items-center">
              <img
                className="w-[104px] h-5"
                src=" https://tomedes.gumlet.io/assets/images/amazon_1.svg"
                alt="amazon"
              />
              <img
                src="https://tomedes.gumlet.io/assets/images/quote_images/google_1.svg"
                alt="google"
                className="w-[85px] h-7"
              />
              <MicrosoftSvg />
              <YoutubeSvg />
              <BloombergSvg />
              <SpotifySvg />
              <img
                src="https://tomedes.gumlet.io/assets/clients/logo-salesforce.svg"
                alt="CodeOrg"
                className="w-[4rem] h-11"
              />
              <WixSvg />
              <HsbcSvg />
              <img
                src="https://tomedes.gumlet.io/assets/icons/canon.png"
                alt="canon"
                className="w-[89px] h-5"
              />
              <img
                src="https://tomedes.gumlet.io/assets/images/mgm.png"
                alt="mgm"
                className="w-14 h-11"
              />
              <img
                src="https://tomedes.gumlet.io/assets/code.svg"
                alt="CodeOrg"
                className="w-10 h-10"
              />
              <SapSvg />
              <img
                src="https://tomedes.gumlet.io/assets/clients/OECD-02.png"
                alt="CodeOrg"
                className="w-[6rem]"
              />
            </div>
          </div>
        ) : (
          <div className="mx-auto pt-10 text-center">
            <div className="w-11/12 ml-6 sm:ml-0 sm:w-full grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 sm:gap-7 2xl:gap-10 justify-items-center md:justify-items-center pt-[15px] items-center">
              <OptimizedImage
                className="w-[104px] h-5"
                src=" https://tomedes.gumlet.io/assets/images/amazon_1.svg"
                alt="amazon"
              />
              <OptimizedImage
                src="https://tomedes.gumlet.io/assets/images/quote_images/google_1.svg"
                alt="google"
                className="w-[85px] h-7"
              />
              <MicrosoftSvg />
              <YoutubeSvg />
              <BloombergSvg />
              <SpotifySvg />
              <WixSvg />
              <HsbcSvg />
              <OptimizedImage
                src="https://tomedes.gumlet.io/assets/icons/canon.png"
                alt="canon"
                className="w-[89px] h-5"
              />
              <OptimizedImage
                src="https://tomedes.gumlet.io/assets/images/mgm.png"
                alt="mgm"
                className="w-14 h-11"
              />
              <OptimizedImage
                src="https://tomedes.gumlet.io/assets/code.svg"
                alt="CodeOrg"
                className="w-10 h-10"
              />
              <SapSvg />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
